import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MessageDialogService } from '../../services/helper/message-dialog.service';
import { MatIconModule } from '@angular/material/icon';
import { IDialogErrorData } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-dialog-error-modal',
  standalone: true,
  imports: [MatDialogModule, MatDialogActions, MatDialogClose, MatButtonModule, ClipboardModule, MatIconModule],
  templateUrl: './dialog-error-modal.component.html',
  styleUrl: './dialog-error-modal.component.scss',
})
export class DialogErrorModalComponent {
  readonly data = inject<IDialogErrorData>(MAT_DIALOG_DATA);
  displayErrorMainMessage: string;
  displayErrorSecondaryMessage: string = '';
  displayErrorNumber: string = '';
  errMessageCopyData: string = '';

  #_dialogService = inject(MessageDialogService);

  ngOnInit(): void {
    this.displayErrorMainMessage = this.data.displayErrorMainMessage;
    this.displayErrorSecondaryMessage = this.data.displayErrorSecondaryMessage;
    this.displayErrorNumber = this.data.displayErrorNumber;
    this.errMessageCopyData = this.displayErrorMainMessage + ' Error Number: ' + this.displayErrorNumber;
  }

  onCopyMessage(message: string): void {
    this.#_dialogService.snackBarTopCenterTimed(message, 3000);
  }
}
